import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between w-full" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-5 text-4xl font-bold text-primary-700 lg:mb-0" }, "Your Patient Record")
], -1)
const _hoisted_2 = {
  key: 1,
  class: ""
}
const _hoisted_3 = { class: "p-5 mb-6 bg-white rounded-lg" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Patient Details", -1)
const _hoisted_5 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_6 = { class: "col-span-full lg:col-span-6 space-y-2.5 lg:mb-14" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "First Name", -1)
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Middle Name", -1)
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Last Name", -1)
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "col-span-full lg:col-span-6 space-y-2.5 lg:mb-14" }
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Date of Birth", -1)
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Sex", -1)
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = { class: "flex justify-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Nationality", -1)
const _hoisted_25 = { class: "font-bold" }
const _hoisted_26 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Civil Status", -1)
const _hoisted_29 = { class: "font-bold" }
const _hoisted_30 = { class: "flex justify-between" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "Email Address", -1)
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_34 = { class: "flex justify-between" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Telephone Number", -1)
const _hoisted_36 = { class: "font-bold" }
const _hoisted_37 = { class: "flex justify-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "Cellphone Number", -1)
const _hoisted_39 = { class: "font-bold" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 font-bold text-primary-500" }, "Local Address", -1)
const _hoisted_42 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_43 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_44 = { class: "flex justify-between" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "Province", -1)
const _hoisted_46 = { class: "font-bold" }
const _hoisted_47 = { class: "flex justify-between" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, "Barangay", -1)
const _hoisted_49 = { class: "font-bold" }
const _hoisted_50 = { class: "flex justify-between" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, "No./Bldg.", -1)
const _hoisted_52 = { class: "font-bold" }
const _hoisted_53 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_54 = { class: "flex justify-between" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", null, "City/Municipality", -1)
const _hoisted_56 = { class: "font-bold" }
const _hoisted_57 = { class: "flex justify-between" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", null, "Street", -1)
const _hoisted_59 = { class: "font-bold" }
const _hoisted_60 = { class: "flex justify-between" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", null, "ZIP Code", -1)
const _hoisted_62 = { class: "font-bold" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 font-bold text-primary-500" }, "Permanent Address", -1)
const _hoisted_65 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_66 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_67 = { class: "flex justify-between" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", null, "Province", -1)
const _hoisted_69 = { class: "font-bold" }
const _hoisted_70 = { class: "flex justify-between" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", null, "Barangay", -1)
const _hoisted_72 = { class: "font-bold" }
const _hoisted_73 = { class: "flex justify-between" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", null, "No./Bldg.", -1)
const _hoisted_75 = { class: "font-bold" }
const _hoisted_76 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_77 = { class: "flex justify-between" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", null, "City/Municipality", -1)
const _hoisted_79 = { class: "font-bold" }
const _hoisted_80 = { class: "flex justify-between" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", null, "Street", -1)
const _hoisted_82 = { class: "font-bold" }
const _hoisted_83 = { class: "flex justify-between" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", null, "ZIP Code", -1)
const _hoisted_85 = { class: "font-bold" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_87 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_88 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_89 = { class: "flex justify-between" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("p", null, "PhilHealth No", -1)
const _hoisted_91 = { class: "font-bold" }
const _hoisted_92 = { class: "col-span-full lg:col-span-6 space-y-2.5 lg:mb-2.5" }
const _hoisted_93 = { class: "flex justify-between" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("p", null, "HMO", -1)
const _hoisted_95 = { class: "font-bold" }
const _hoisted_96 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_97 = { class: "flex justify-between" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("p", null, "Senior Citizen ID", -1)
const _hoisted_99 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_100 = { class: "flex justify-between" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("p", null, "PWD ID", -1)
const _hoisted_102 = { class: "p-5 mb-6 bg-white rounded-lg" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Occupation", -1)
const _hoisted_104 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_105 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_106 = { class: "flex justify-between" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("p", null, "Title", -1)
const _hoisted_108 = { class: "font-bold" }
const _hoisted_109 = { class: "flex justify-between" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("p", null, "Contact Number", -1)
const _hoisted_111 = { class: "font-bold" }
const _hoisted_112 = { class: "flex justify-between" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", null, "Company Email Address", -1)
const _hoisted_114 = { class: "font-bold" }
const _hoisted_115 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_116 = { class: "flex justify-between" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("p", null, "Company Name", -1)
const _hoisted_118 = { class: "font-bold" }
const _hoisted_119 = { class: "flex justify-between" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("p", null, "Address", -1)
const _hoisted_121 = { class: "font-bold text-right max-w-[70%]" }
const _hoisted_122 = { class: "p-5 mb-2 bg-white rounded-lg" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "Person to notify in case of emergency", -1)
const _hoisted_124 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_125 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_126 = { class: "flex justify-between" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("p", null, "Name", -1)
const _hoisted_128 = { class: "font-bold" }
const _hoisted_129 = { class: "flex justify-between" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("p", null, "Contact Number", -1)
const _hoisted_131 = { class: "font-bold" }
const _hoisted_132 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_133 = { class: "flex justify-between" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("p", null, "Relationship", -1)
const _hoisted_135 = { class: "font-bold" }
const _hoisted_136 = { class: "flex justify-between" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("p", null, "Email Address", -1)
const _hoisted_138 = { class: "font-bold" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-darkgray-400" }, [
  /*#__PURE__*/_createTextVNode("If you want to make any changes to any of the information shown above, you may contact us via our trunkline "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:(02) 736-85239",
    class: "font-bold"
  }, "(02) 736-85239"),
  /*#__PURE__*/_createTextVNode(".")
], -1)

import PortalLayout from '@/layouts/PortalLayout.vue';
import MedicalRecordForm from './MedicalRecordForm.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import VueBarcode from '@chenfengyuan/vue-barcode';
import UploadIDModal from "@/components/modal/UploadIDModal.vue";
import { useRouter } from 'vue-router';
import { BellIcon } from '@heroicons/vue/24/outline';

import patient from "@/classes/UserData";
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const patientData = computed(() => patient.getCurrentUser())

const router = useRouter();

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const showSrIdUpload = ref<boolean>(false)
const showPwdIdUpload = ref<boolean>(false)

const hasRecord = computed(() => {
    console.log(patientData.value);
    return (patientData.value.cellphone_number !== null && patientData.value.cellphone_number !== "TBA")
        && (patientData.value.province !== null && patientData.value.province !== "TBA")
        && (patientData.value.city !== null && patientData.value.city !== "TBA")
        && (patientData.value.barangay !== null && patientData.value.barangay !== "TBA")
        && (patientData.value.street !== null && patientData.value.street !== "TBA")
        && (patientData.value.company_name !== null && patientData.value.company_name !== "TBA")
        && (patientData.value.company_address !== null && patientData.value.company_address !== "TBA")
        && (patientData.value.contact_person_name !== null && patientData.value.contact_person_name !== "TBA")
        && (patientData.value.contact_person_number !== null && patientData.value.contact_person_number !== "TBA")
        && (patientData.value.contact_person_relationship !== null && patientData.value.contact_person_relationship !== "TBA");
});

const viewID = (base64: string): void => {
    const pattern = /data:image\/[^;]+;base64,+/;
    base64 = base64.replace(pattern, "");

    const mime = getMimeType(base64);
    const decodedString = atob(base64);
    const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
    const blob = new Blob([uint8Array], { type: mime });
    const testResultFile = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = testResultFile;
    link.target = '_blank';
    link.click();
}

const getMimeType = (base64:string):string|null => {
    const signatures = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpeg"
    };

    for (const index in signatures) {
        if (base64.indexOf(index) === 0) {
            return signatures[index];
        }
    }
    
    return null;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PortalLayout, { defaultTitle: false }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      fields: _withCtx(() => [
        (hasRecord.value)
          ? (_openBlock(), _createBlock(_unref(VueBarcode), {
              key: 0,
              value: patientData.value.hospital_no,
              options: { displayValue: true },
              class: "mr-6"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (!hasRecord.value)
          ? (_openBlock(), _createBlock(MedicalRecordForm, { key: 0 }))
          : _createCommentVNode("", true),
        (hasRecord.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("p", _hoisted_9, _toDisplayString(patientData.value.first_name ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("p", _hoisted_12, _toDisplayString(patientData.value.middle_name ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("p", _hoisted_15, _toDisplayString(patientData.value.last_name ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("p", _hoisted_19, _toDisplayString(patientData.value.birthdate ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("p", _hoisted_22, _toDisplayString(patientData.value.sex ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, _toDisplayString(patientData.value.nationality ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("p", _hoisted_29, _toDisplayString(patientData.value.civil_status ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("p", _hoisted_32, _toDisplayString(patientData.value.email_address ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("p", _hoisted_36, _toDisplayString(patientData.value.telephone_number ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("p", _hoisted_39, "+63 " + _toDisplayString(patientData.value.cellphone_number ?? '-'), 1)
                    ])
                  ])
                ]),
                _hoisted_40,
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("p", _hoisted_46, _toDisplayString(patientData.value.province ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("p", _hoisted_49, _toDisplayString(patientData.value.barangay ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("p", _hoisted_52, _toDisplayString(patientData.value.building_number ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("p", _hoisted_56, _toDisplayString(patientData.value.city ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("p", _hoisted_59, _toDisplayString(patientData.value.street ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("p", _hoisted_62, _toDisplayString(patientData.value.zip_code ?? '-'), 1)
                    ])
                  ])
                ]),
                _hoisted_63,
                _hoisted_64,
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("p", _hoisted_69, _toDisplayString(patientData.value.permanent_province ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("p", _hoisted_72, _toDisplayString(patientData.value.permanent_barangay ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("p", _hoisted_75, _toDisplayString(patientData.value.permanent_building_number ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("p", _hoisted_79, _toDisplayString(patientData.value.permanent_city ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createElementVNode("p", _hoisted_82, _toDisplayString(patientData.value.permanent_street ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _createElementVNode("p", _hoisted_85, _toDisplayString(patientData.value.permanent_zip_code ?? '-'), 1)
                    ])
                  ])
                ]),
                _hoisted_86,
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createElementVNode("p", _hoisted_91, _toDisplayString(patientData.value.philhealth_number ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      _createElementVNode("p", _hoisted_95, _toDisplayString(patientData.value.hmo_name ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _hoisted_98,
                      (patientData.value.senior_citizen_id_base_64)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "font-bold transition cursor-pointer text-primary-500 hover:text-primary-700",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (viewID(patientData.value.senior_citizen_id_base_64)))
                          }, " View ID "))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "font-bold transition cursor-pointer text-primary-500 hover:text-primary-700",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showSrIdUpload.value = true))
                          }, " Upload ID "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, [
                      _hoisted_101,
                      (patientData.value.pwd_id_base_64)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "font-bold transition cursor-pointer text-primary-500 hover:text-primary-700",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (viewID(patientData.value.pwd_id_base_64)))
                          }, " View ID "))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "font-bold transition cursor-pointer text-primary-500 hover:text-primary-700",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (showPwdIdUpload.value = true))
                          }, " Upload ID "))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("div", _hoisted_106, [
                      _hoisted_107,
                      _createElementVNode("p", _hoisted_108, _toDisplayString(patientData.value.job_title ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _hoisted_110,
                      _createElementVNode("p", _hoisted_111, "+63 " + _toDisplayString(patientData.value.company_contact_no ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _hoisted_113,
                      _createElementVNode("p", _hoisted_114, _toDisplayString(patientData.value.company_email ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _hoisted_117,
                      _createElementVNode("p", _hoisted_118, _toDisplayString(patientData.value.company_name ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _createElementVNode("p", _hoisted_121, _toDisplayString(patientData.value.company_address ?? '-'), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_122, [
                _hoisted_123,
                _createElementVNode("div", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, [
                      _hoisted_127,
                      _createElementVNode("p", _hoisted_128, _toDisplayString(patientData.value.contact_person_name ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _hoisted_130,
                      _createElementVNode("p", _hoisted_131, "+63 " + _toDisplayString(patientData.value.contact_person_number ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, [
                      _hoisted_134,
                      _createElementVNode("p", _hoisted_135, _toDisplayString(patientData.value.contact_person_relationship ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _createElementVNode("p", _hoisted_138, _toDisplayString(patientData.value.contact_person_email ?? '-'), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_139
            ]))
          : _createCommentVNode("", true),
        (loader.value)
          ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
          : _createCommentVNode("", true),
        _createVNode(ErrorModal, {
          width: "w-[548px]",
          title: "Error",
          "action-text": "Close",
          "cancel-text": "Go back",
          show: showError.value,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
          onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false))
        }, {
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(errorMsg.value), 1)
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _: 1
    }),
    _createVNode(UploadIDModal, {
      title: "Upload Senior Citizen ID",
      dialog: showSrIdUpload.value,
      patientId: patientData.value.patient_id,
      type: "sr_id",
      "import-route": "medical-record/upload-patient-id",
      onOnClose: _cache[6] || (_cache[6] = ($event: any) => (showSrIdUpload.value = false))
    }, null, 8, ["dialog", "patientId"]),
    _createVNode(UploadIDModal, {
      title: "Upload PWD ID",
      dialog: showPwdIdUpload.value,
      patientId: patientData.value.patient_id,
      type: "pwd_id",
      "import-route": "medical-record/upload-patient-id",
      onOnClose: _cache[7] || (_cache[7] = ($event: any) => (showPwdIdUpload.value = false))
    }, null, 8, ["dialog", "patientId"])
  ], 64))
}
}

})